import { useLocalObservable } from 'mobx-react-lite';

import { ProviderUid } from '@gem/call/CallProviders/callProviders.types';
import { Call } from '@gem/call/CallStore/Call';
import { Opponent } from '@gem/call/CallStore/Opponent/Opponent';
import { useCallContext } from '@gem/call/CallView/CallView.context';

interface IOpponentVideoItem {
  opponentPosition: number;
  opponent: Opponent | null;
  ongoingCall: Call;
  onOpponentClick(): void;
}

export const useOpponentVideoItem = (
  opponentUid: ProviderUid,
  isGridLayout?: boolean
): IOpponentVideoItem => {
  const context = useCallContext();

  const presenter = useLocalObservable<IOpponentVideoItem>(() => ({
    get ongoingCall(): Call {
      return context.call;
    },

    get opponentPosition(): number {
      return presenter.ongoingCall.opponentsPositions.opponentsPositions[opponentUid];
    },

    get opponent(): Opponent | null {
      return presenter.ongoingCall.opponents.getOpponent(opponentUid) || null;
    },

    onOpponentClick(): void {
      if (isGridLayout) {
        context.callController.toggleGridLayout(presenter.opponent);
      }
    },
  }));

  return presenter;
};
